export const getRoaQuoteTools = state => state.roaQuoteTools;
